import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { Form, Input, Button } from "antd";
import { verificationPattern } from "../ForgotPassword/rules";
const VerificationCodeLogin = () => {
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(
    Form,
    {
      size: "large",
      onFinish: async (v) => {
        console.log(v);
      },
      children: [
        /* @__PURE__ */ jsx(
          Form.Item,
          {
            name: "verifyCode",
            rules: [
              {
                required: true,
                message: "\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801"
              }
            ],
            children: /* @__PURE__ */ jsx(Input, { placeholder: "\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801", suffix: /* @__PURE__ */ jsx("a", { children: "\u83B7\u53D6\u9A8C\u8BC1\u7801" }) })
          }
        ),
        /* @__PURE__ */ jsx(
          Form.Item,
          {
            name: "verifyCode",
            rules: [
              {
                required: true,
                message: "\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801"
              },
              verificationPattern
            ],
            children: /* @__PURE__ */ jsx(Input, { placeholder: "\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801", suffix: /* @__PURE__ */ jsx("a", { children: "\u83B7\u53D6\u9A8C\u8BC1\u7801" }) })
          }
        ),
        /* @__PURE__ */ jsx(Form.Item, { children: /* @__PURE__ */ jsx(Button, { type: "primary", htmlType: "submit", style: { width: "100%" }, children: "\u767B\u5F55" }) })
      ]
    }
  ) });
};
var VerificationCodeLogin_default = VerificationCodeLogin;
export {
  VerificationCodeLogin_default as default
};
